import logo from "assets/images/integrations/cleverreach_logo.png";
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { OAuthSetup } from "../../components/OAuthSetup/OAuthSetup";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { CleverReachIntegrationSettings } from "./types";

type CleverReachConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShop = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShop"
  ]) as string;

  return {
    integrationList: state
      .getIn([
        "customerBackendDashboard",
        "shops",
        selectedShop,
        "integrations",
        "data",
        IntegrationType.CLEVERREACH
      ])
      ?.toJS() as CleverReachIntegrationSettings[] | undefined
  };
};

const connector = connect(mapStateToProps);

type CleverReachConnectViewComponentProps = CleverReachConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const CleverReachConnectViewComponent = (props: CleverReachConnectViewComponentProps) => {
  const { connectingType, onStartConnecting, onStopConnecting, integrationList } = props;

  const handleConnect = useCallback(() => {
    onStartConnecting(IntegrationType.CLEVERREACH);
  }, [onStartConnecting]);

  const isConnected = useMemo(
    () =>
      integrationList?.some((integration) => {
        return integration.oath2Config && integration.oath2Config.access_token;
      }) || false,
    [integrationList]
  );

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.CLEVERREACH && (
        <OAuthSetup integrationType={IntegrationType.CLEVERREACH} onFinish={onStopConnecting} />
      )}
      <AvailableIntegrationCardHeader image={logo} text="Cleverreach" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Long.Explanation"
          defaultMessage="Connect your {tool} account with uptain. Then new newsletter subscribers can be added to your account and you can use whitelists for Abandonment-Mails."
          values={{ tool: "Cleverreach" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={connectingType !== undefined}
        onConnect={handleConnect}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const CleverReachConnectView = connector(CleverReachConnectViewComponent);
